import { useMutation } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { reportsService } from '@/services/reports.service';
import type { SmsReportExportRequest } from '@/types/reports';

export const useExportSmsReportMutation = () => {
  return useMutation({
    mutationFn: (payload: SmsReportExportRequest) => reportsService.exportSmsReport(payload),
    onError: () => {
      showNotification({
        title: 'Error',
        message: 'Failed to download SMS report. Please try again.',
        color: 'red',
      });
    },
  });
};
